/**
 * Status chips — verdict + lot-statut. Always combine COLOR + GLYPH + TEXT (never color alone —
 * daltonisme + médico-légal). Thin wrappers over the UI Badge that map a verdict/statut to its
 * tone + mandated glyph + label.
 */
import { Badge } from "@/ui";
import { useT } from "@/app";
import type { LotStatut, Verdict } from "../types";
import { lotStatutVisual, verdictVisual } from "../lib";

export function VerdictBadge({ verdict }: { verdict: Verdict }) {
  const { t } = useT();
  const v = verdictVisual(verdict);
  return (
    <Badge tone={v.tone} glyph={v.glyph}>
      {t(v.labelKey)}
    </Badge>
  );
}

export function LotStatutBadge({ statut }: { statut: LotStatut }) {
  const { t } = useT();
  const v = lotStatutVisual(statut);
  return (
    <Badge tone={v.tone} glyph={v.glyph}>
      {t(v.labelKey)}
    </Badge>
  );
}
